// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Badge_badgeWrapper__Rfb13","homepage":"Badge_homepage__gotLl","hide":"Badge_hide__Bt7C1","floating":"Badge_floating__2raQl"};